import api from "../../../api/index";

export function doctorDashboard(queryParams){
    return api.get(`v2/assigned_patients${queryParams}`);
}
export function doctorDashboardPage(page){
    return api.get(`v2/assigned_patients?pageNo=${page}`)
}

export function writeBulkPrescription(id){
    return api.post(`bulk_prescription/${id}`)
}

export function myAppointmentData(sd, ed){
    if(sd && ed && sd!="undefined" && ed !="undefined" && sd !="null" && ed !="null"){
        return api.get(`v4/consult-doctor-bookings?startDate=${sd}&endDate=${ed}`);
    }
}

export const doctorAppointmentApi = (caseID) =>{
    return api.get(`v4/paid-dbooking/${caseID}`)
} 
